<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>

      <v-flex xs10 md6 lg4 v-if="connected === true && online === true">
        <v-text-field autofocus :label="$t('enter_license')" outline class="mt-4 mb-3" v-model="license" hide-details placeholder="ex: 68hd64"></v-text-field>
        <v-btn color="primary darken-2"  block large @click="nextb()" class="mb-3">{{ $t('nextb') }}</v-btn>
        <div class="px-3 orange--text text--darken-4 body-2 text-xs-center">
          <div>{{ $t('havenot_yet1') }}<br><a :href="$t('jasma_remote_url')" class="title" color="primary">Prayer Times on TV remote</a> {{ $t('at_playstore') }}</div>
        </div>
      </v-flex>      

      <v-flex xs10 md6 lg4 class="display-1 text-xs-center" v-else>
            <v-progress-circular
              :size="100"
              :width="10"
              color="primary"
              indeterminate
            ></v-progress-circular>
      <div class="ma-5">{{ $t('search_server') }}</div>
      </v-flex>



    </v-layout>
  </v-container>
</template>

<script>
export default{
  data(){
    return{      
      license: "",
      UserId: "",  
      connected: false,
      hasLicense: false,
      serverIp:'',
      online:  process.env.VUE_APP_SERVED == 'online' ? true : false
      // fetchInterval:''
    }
  },

  created(){
    // console.log(location.replace('metalika')) 
    if(process.env.VUE_APP_SERVED == "server") this.serverIp = process.env.VUE_APP_LOCAL_SERVER_IP        
    if(process.env.VUE_APP_SERVED == "client") this.serverIp = process.env.VUE_APP_REMOTE_SERVER_IP            
    if(process.env.VUE_APP_SERVED == "online") this.serverIp = process.env.VUE_APP_EXTERNAL_SERVER_IP  

    this.license = localStorage.getItem('license')
    this.UserId = localStorage.getItem('UserId')
        
    this.runConnecting()
  },

  sockets:{
    connect(){            
      //console.log('connected to server')
      // this.connected = true
    },
    
  },


  methods:{
    runConnecting(){
      this.axios.get('/ping')
        .then(res=>{
          if(res.data == "pong"){
            this.connected = true
          }
          this.connecting()
        })
        .catch(()=>{          
          setTimeout(this.runConnecting(), 1500)
        })

    },

    connecting(){
      if(process.env.VUE_APP_SERVED == "online"){        
        if(this.license != "" && this.license !== null) {
          this.axios.get('/settings-license/' + this.license)
          .then(res=>{
            if(res.data != ''){
              localStorage.setItem('license', res.data.license)
              localStorage.setItem('UserId', res.data.UserId)
              this.$router.push('/lic/'+ res.data.license)
            } else {
              this.$swal({
                type: 'warning',
                title: this.$i18n.t('licence_not_found'),
                html: this.$i18n.t('get_free_license')
              }) 
              localStorage.setItem('license', '')
              localStorage.setItem('UserId', '')              
            }            
          })
          .catch(()=>{
            setTimeout(()=>{
              this.runConnecting()
            }, 1000)            
          })
        } 
      } else {        
        this.axios.get('/u/settings/1')
        .then(res=>{
          localStorage.setItem('license', res.data.license)
          localStorage.setItem('UserId', 1)
          this.$router.push('/lic/'+ res.data.license)        
        })
        .catch(()=>{
          this.$swal({
            type: 'warning',
            title: "Error",
            html: "Undefined error"
          })           
        })
      }

      
      // if(this.license != "" && this.license !== null) {
      //   this.axios.get('/settings-license/' + this.license)
      //   .then(res=>{
      //     if(res.data != ''){
      //       this.axios.get('/u/settings/'+ res.data.UserId)
      //       .then(res=>{              
      //         this.$router.push('/lic/'+ res.data.license)
      //       })
      //       .catch(()=>{
      //         this.runConnecting()
      //       })
      //     } else {
      //       this.$swal({
      //         type: 'warning',
      //         title: this.$i18n.t('licence_not_found'),
      //         html: this.$i18n.t('get_free_license')
      //       }) 
      //       localStorage.setItem('license', '')
      //       localStorage.setItem('UserId', '')            
      //       this.$router.push('/lic/'+ res.data.license)
      //     }
      //   })
      //   .catch(err=>{
      //     console.log(err.response.data.error)
      //   })
      // } else {
      //   if(process.env.VUE_APP_SERVED != "online"){
      //     this.axios.get('/u/settings/1')
      //       .then(res=>{
      //         localStorage.setItem('license', res.data.license)
      //         localStorage.setItem('UserId', 1)
      //         this.$router.push('/lic/'+ res.data.license)
      //       })
      //   }
      // }

    },

    nextb(){
      if(this.license == '' || this.license == null){
        this.$swal({
          title: this.$i18n.t('licence_required'),
          html: this.$i18n.t('get_free_license'),
          type: 'warning'
        })
      } else {

        this.axios.get('/settings-license/' + this.license)
        .then(res=>{
          if(res.data !=""){
            localStorage.setItem('UserId', res.data.UserId)
            localStorage.setItem('license', res.data.license)
          // window.location.replace('/#/lic/'+ this.license)
            this.connecting()   
          } else {
            this.$swal({
              type: 'warning',
              title: this.$i18n.t('licence_not_found'),
              html: this.$i18n.t('get_free_license')
            }) 

            localStorage.setItem('license', '')
            localStorage.setItem('UserId', '')             
          }
        })
        .catch(()=>{
          this.runConnecting()
        })
      }
    },

  },

  // beforeDestroy(){
  //   clearInterval(this.fetchInterval)
  // }  

}
</script>
